import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Switch from "@material-ui/core/Switch";
import InfoIcon from "@material-ui/icons/Info";
import EditSponsorElement from "../EditSponsorElement";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";

export default class EditPouleDialog extends React.Component {
  componentDidMount = () => {
    // update possbily changed scoreType
    if (
      this.props.poule &&
      this.props.poule.scoreType &&
      this.props.poule.scoreType !== this.props.scoreType
    ) {
      this.props.setScoreType(this.props.poule.scoreType);
    }

    if (!this.props.poule) {
      this.props.setScoreType(
        ((this.props.tournament.scoringTypesPerDivisionPerPhase || {})[
          this.props.division.id
        ] || {})[this.props.fase] || "default"
      );
    }
  };
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {this.props.poule
            ? this.props.singleMatch
              ? languages.structure.editSingleMatch
              : languages.structure.editPoule
            : this.props.singleMatch
            ? languages.structure.addSingleMatch
            : languages.structure.addPoule}
        </DialogTitle>
        <form>
          <DialogContent style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}>
            <DialogContentText />
            {this.props.poule && (
              <TextField
                autoFocus
                margin="normal"
                label={languages.general.name}
                value={this.props.name}
                name="name"
                onChange={this.props.handleChange}
                type="text"
                fullWidth
              />
            )}

            {!this.props.singleMatch && (
              <TextField
                label={languages.formatString(
                  languages.structure.pouleSize,
                  this.props.tournament.individualPlayers
                    ? languages.teams.playersLow
                    : languages.tournament.teamsLow
                )}
                value={this.props.pouleSize}
                type="number"
                onChange={this.props.handlePouleSizeChange}
                margin="normal"
                fullWidth
              />
            )}

            {Object.keys(this.props.tournament.scoringTypes || {}).length >
              0 && (
              <FormControl style={{ width: "100%", marginTop: 20 }}>
                <InputLabel style={{ width: "100%" }} htmlFor="scoreType">
                  {languages.structure.scoring}
                </InputLabel>
                <Select
                  style={{ maxWidth: "100%" }}
                  value={this.props.scoreType}
                  onChange={this.props.handleChange}
                  inputProps={{
                    name: "scoreType",
                    id: "scoreType",
                  }}
                >
                  <MenuItem value={"default"}>
                    {languages.structure.scoring + " 1"}
                  </MenuItem>
                  {Object.keys(this.props.tournament.scoringTypes)
                    .sort((a, b) => a - b)
                    .map((key, i) => {
                      return (
                        <MenuItem key={key} value={key}>
                          {languages.structure.scoring +
                            " " +
                            (i + 2).toString()}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            )}

            {(this.props.user.uid === "A1C3ztFFERMyFZlEKGrCEKCGRH03" || // HSSO
              this.props.user.uid === "dLIIgYris4QH9SaFvO1fYkfWhSw2" ||
              this.props.user.uid === "qwVXeKNiBzMz3RyUJSAJFLrkFnH2") &&
              this.props.pouleSize === "36" && (
                <FormControl fullWidth>
                  <InputLabel htmlFor="num-absent">
                    Aantal afwezige teams
                  </InputLabel>
                  <Select
                    value={this.props.numAbsent}
                    onChange={this.props.handleChange}
                    inputProps={{
                      name: "numAbsent",
                      id: "num-absent",
                    }}
                    fullWidth
                  >
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                  </Select>
                </FormControl>
              )}

            <FormControl style={{ marginTop: 20, width: "100%" }}>
              <InputLabel htmlFor="num-encounters">
                {languages.structure.numEncounters}
              </InputLabel>
              <Select
                value={this.props.numEncounters}
                onChange={this.props.handleNumEncountersChange}
                inputProps={{
                  name: "numEncounters",
                  id: "num-encounters",
                }}
                style={{ width: "100%" }}
              >
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={2}>2</MenuItem>
                {Number(this.props.pouleSize) < 11 &&
                  !this.props.belongsToBracket &&
                  [3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
                    <MenuItem key={num} value={num}>
                      {num.toString()}
                    </MenuItem>
                  ))}
              </Select>
              <FormHelperText>
                {languages.formatString(
                  languages.structure.numEncountersDescription,
                  this.props.tournament.individualPlayers
                    ? languages.teams.playerLow
                    : languages.results.teamLow
                )}
              </FormHelperText>
            </FormControl>
            {this.props.showOverwriteWarning && !this.props.showLockMessage && (
              <DialogContentText
                style={{ color: "red", fontSize: 14, marginTop: 10 }}
              >
                {languages.structure.overwriteWarning}
              </DialogContentText>
            )}
            {this.props.showLockMessage && (
              <DialogContentText
                style={{ color: "red", fontSize: 14, marginTop: 10 }}
              >
                {languages.structure.scheduleLockMessage}
              </DialogContentText>
            )}

            {!this.props.belongsToBracket && (
              <div>
                <FormGroup style={{ marginTop: 5 }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.props.showSponsor}
                        onChange={this.props.handleShowSponsorChange}
                        color="primary"
                        name="showSponsor"
                      />
                    }
                    label={
                      this.props.singleMatch
                        ? languages.structure.matchLogo
                        : languages.structure.pouleLogo
                    }
                  />
                  {this.props.showSponsor && (
                    <div>
                      {this.props.allowedToUpload ? (
                        <EditSponsorElement
                          tournament={this.props.tournament}
                          sponsorName={this.props.sponsorName}
                          sponsorLogoURL={this.props.sponsorLogoURL}
                          sponsorStorageRef={this.props.sponsorStorageRef}
                          handleDeleteSponsor={this.props.handleDeleteSponsor}
                          handleUploadStart={this.props.handleUploadStart}
                          handleProgress={this.props.handleProgress}
                          handleUploadError={this.props.handleUploadError}
                          handleUploadSuccess={this.props.handleUploadSuccess}
                          allowedToUpload={this.props.allowedToUpload}
                          handleSponsorNameChange={this.props.handleChange}
                          errorMessage={this.props.errorMessageSponsor}
                          isUploading={this.props.isUploadingSponsor}
                        />
                      ) : (
                        <div
                          style={{
                            background: "rgb(236, 239, 241)",
                            padding: 10,
                            borderRadius: 5,
                          }}
                        >
                          <InfoIcon
                            style={{
                              height: 15,
                              width: 15,
                              top: 2,
                              position: "relative",
                            }}
                          />
                          {" " + languages.upgrade.upgradeTextExtraSponsor}
                          <br />
                          <Button
                            style={{ marginTop: 5 }}
                            variant="contained"
                            onClick={() => {
                              this.props.toggleUpgradeDialog(false);
                            }}
                            color="primary"
                            size="small"
                          >
                            {languages.upgrade.seePackages}
                          </Button>
                        </div>
                      )}
                    </div>
                  )}
                </FormGroup>
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <Button
              onClick={this.props.handleSubmit}
              disabled={
                !this.props.nameValid ||
                !this.props.pouleSizeValid ||
                !this.props.numEncountersValid ||
                this.props.showLockMessage
              }
              variant="contained"
              color="primary"
              type="submit"
            >
              {this.props.poule
                ? languages.general.change
                : languages.general.add}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
